<script setup lang="ts">
import Icon from '@/components/Icon.vue'
import { useToasts } from '@/stores/toasts'

const toasts = useToasts()
</script>

<template>
  <div class="toasts" aria-live="polite">
    <TransitionGroup name="toast">
      <div v-for="t in toasts.items" :key="t.id" class="toast in" @click="toasts.dismiss(t.id)">
        <span v-if="t.icon" class="toast__ico" :style="t.color ? `color:${t.color}` : ''">
          <Icon :name="t.icon" :size="18" />
        </span>
        <div class="toast__body">
          <div class="toast__title">{{ t.title }}</div>
          <div v-if="t.text" class="toast__text">{{ t.text }}</div>
        </div>
        <button v-if="t.action" class="toast__act" @click.stop="toasts.fire(t.id)">{{ t.action }}</button>
      </div>
    </TransitionGroup>
  </div>
</template>
